/**
 * Implementation of a stack backed by an Array.
 * A stack is a LIFO (last in first out) container
 */
export class Stack {
    constructor() {
        this._backing_storage = [];
    }
    get size() {
        return this._backing_storage.length;
    }
    push(value) {
        this._backing_storage.push(value);
    }
    pop() {
        var _a;
        return (_a = this._backing_storage.pop()) !== null && _a !== void 0 ? _a : null;
    }
    peek() {
        var _a;
        return (_a = this._backing_storage[this._backing_storage.length - 1]) !== null && _a !== void 0 ? _a : null;
    }
    contains(value) {
        return this._backing_storage.includes(value);
    }
    clear() {
        this._backing_storage.length = 0;
    }
}
//# sourceMappingURL=Stack.js.map